import React from 'react';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class DailyGrowthMetricTable extends React.Component {
  render() {
    const { t } = this.props;
    const rows = this.props.data.map((row, index) => {
      return (
        <tr key={index}>
          <td>{row.metric}</td>
          <td>{row.metricToday}</td>
          <td>{row.metricWTD}</td>
          <td>{row.metricMTD}</td>
          <td>{row.metricYTD}</td>
        </tr>
      );
    });

    return (
      <div>
        <p className="lead">{this.props.title}</p>
        <Table bordered hover striped responsive className="reporting-table">
          <thead>
            <tr>
              <th>-</th>
              <th>{t('TODAY')}</th>
              <th>{t('WTD')}</th>
              <th>{t('MTD')}</th>
              <th>{t('YTD')}</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(DailyGrowthMetricTable);
